import type { TLabel } from './label';
import type { TLead } from './lead';
import type { TMedia } from './media';
import type { TOrganization } from './organization';
import type { TProgram } from './program';
import type { TSubmission } from './submission';
import type { TTaskComment } from './task-comment';
import type { TUser } from './user';
import type { ValueOf } from './utilities';

export const TASK_PRIORITY = {
  low: 'LOW',
  normal: 'NORMAL',
  medium: 'MEDIUM',
  high: 'HIGH',
  urgent: 'URGENT',
} as const;

export const TASK_STATUS = {
  todo: 'TODO',
  inProgress: 'IN_PROGRESS',
  closed: 'CLOSED',
  overdue: 'OVERDUE',
} as const;

export type TTaskDbStatus = {
  id: number;
  created_at: string;
  updated_at: string;
  order: number;
  name: string;
  description: string;
  is_active: boolean;
  organization: number;
  created_by: number;
  updated_by: number;
};

export type TTask = {
  id: number;
  workspace: number | null;
  reporter: TUser;
  assignees: TUser[];
  watchers: TUser[];
  students: TUser[];
  leads: TLead[];
  labels: TLabel[];

  organization: TOrganization;
  attachments: TMedia[];
  program: TProgram;
  submission: TSubmission;
  task_comments: TTaskComment[];
  created_at: string;
  updated_at: string;
  sharable_uid: number;
  formatted_sharable_uid: string;
  name: string;
  content: string;
  priority: ValueOf<typeof TASK_PRIORITY>;
  status: number;
  db_status?: TTaskDbStatus;
  due_date: string;
  is_overdue: boolean;
  completed_at: string;
  note: string;
};

export type TTaskStatuses = {
  id: number;
  color: string;
  className: string;
  created_at: string;
  updated_at: string;
  order: number;
  name: string;
  description: string;
  is_active: boolean;
  organization: number;
  created_by: number;
  updated_by: number;
};

export type TTaskWorkspace = {
  id: number;
  name: string;
  description: string;
  is_active: boolean;
  organization: number;
  created_by: number;
  updated_by: number;
  is_private: boolean;
  no_tasks: number;
};
